import { useMsal } from "@azure/msal-react";
import React from "react";
import { callMsGraph } from "../auth/graphService";
import { TableUsers } from "../storage/tableStorage";

export default function useUserData() {
    const [userData, setUserData] = React.useState(null);
    const { instance, accounts } = useMsal();

    React.useEffect(() => {
        if (accounts.length > 0) {
            callMsGraph(instance, accounts[0]).then(async (r) => {
                const id = r.surname + r.givenName;

                try {
                    // 🔎 On tente de récupérer l'utilisateur
                    const u = await TableUsers.getEntity(id, id);

                    setUserData({
                        nom: u.nom,
                        prenom: u.prenom,
                        mail: u.mail,
                        id: u.id,
                        favorisVideo: u.favorisVideo
                            ? JSON.parse(u.favorisVideo)
                            : [],
                        favorisAnatomie3D: u.favorisAnatomie3D
                            ? JSON.parse(u.favorisAnatomie3D)
                            : [],
                    });
                } catch (error) {
                    if (error.statusCode === 404) {
                        // 👤 Utilisateur inexistant → on le crée
                        const newUser = {
                            partitionKey: id,
                            rowKey: id,
                            nom: r.surname,
                            prenom: r.givenName,
                            mail: r.mail,
                            favorisVideo: JSON.stringify([]),
                            favorisAnatomie3D: JSON.stringify([]),
                        };

                        await TableUsers.createEntity(newUser);

                        setUserData(newUser);
                    } else {
                        console.error("Erreur TableUsers :", error);
                    }
                }
            });
        }
    }, [accounts, instance]);

    return { userData };
}
